import moment from "moment";

/**
 * Checks if the user needs a guardian based on the minimum age.
 * @param birthday: string - The birthday of the user.
 * @minimumAge: number - The minimum age required to self register
 * @orgaSkipGuardians: boolean - Flag indicating whether orga has confirmed guardians consent
 * @returns
 */
export const userNeedsAGuardian = (
  birthday: string,
  minimumAge: number,
  orgaSkipGuardians?: boolean
) => {
  const todayMinusMinimumAge = moment().startOf("day").subtract(minimumAge, "years");
  const parsedBirthday = moment(
    birthday,
    [moment.ISO_8601, "DD.MM.YYYY", "YYYY-MM-DD"],
    true
  ).startOf("day");


  if (orgaSkipGuardians || parsedBirthday.isSameOrBefore(todayMinusMinimumAge)) {
    return false;
  }
  return true;
};